/**
 * Query Builder（SortableDrag / 多维 Analysis）槽位与计算模式契约。
 *
 * @core 建图拖拽区 slot key、表格聚合/明细模式、拖拽校验错误码；
 *       跨 pages + components 共用，语义属 chartEditor 而非 SortableDrag 组件私有。
 */

/** QB 槽位 key，与 Redux/model 字段名一致。 */
export const SortableType = {
  Filter: 'columnFilters',
  Compare: 'columnCompares',
  Metric: 'columnMetrics',
  Dimension: 'columnDimensions',
  ShowDimension: 'columnShowDimensions',
  RawColumn: 'columnRawColumns',
  XColumn: 'columnX',
} as const;

export type TSortableType = (typeof SortableType)[keyof typeof SortableType];

/** Sortable 列表尾部占位类型（占位符 / 错误提示）。 */
export const SortableAfter = {
  Placeholder: '1',
  ErrorMessage: '2',
} as const;

export type TSortableAfter = (typeof SortableAfter)[keyof typeof SortableAfter];

/**
 * 图表计算模式：聚合 vs 原始明细（表格 raw_data）。
 * 与 API `query_mode` 字符串对齐。
 */
export const ChartCalculateMode = {
  Aggregate: 'aggregate',
  RawColumn: 'raw_data',
} as const;

export type TChartCalculateMode =
  (typeof ChartCalculateMode)[keyof typeof ChartCalculateMode];

/** 拖拽校验错误码（SortableDrag dragOnMove / validateColumns）。 */
export const ErrorDragType = {
  Sensitive: 'sensitive',
  Custom: 'custom',
  Same: 'same',
  Max: 'max',
  Empty: 'empty',
} as const;

export type TErrorDragType = (typeof ErrorDragType)[keyof typeof ErrorDragType];
